import { QueryFunctionContext } from '@tanstack/react-query';
import api from 'services/api/api';

export const getDesiredStock = async ({
	queryKey,
}: QueryFunctionContext<string[], any>) => {
	const [, ciclo, ano] = queryKey;
	const response = await api.get(
		`/EstoqueDesejado/EstoqueDesejadoByAnoCiclo?ano=${ano}&ciclo=${ciclo}`
	);
	return response.data;
};

export const deleteDesiredStock = async (id: number) => {
	const response = await api.delete(`estoquedesejado?id=${id}`);
	return response.data;
};

export const getStockOrientation = async ({
	queryKey,
}: QueryFunctionContext<string[], any>) => {
	const [, ciclo, ano, familiaId] = queryKey;

	return api.get(
		`/venda/projecaoEstoque?familia_id=${familiaId}&ano=${ano}&ciclo=${ciclo}`
	);
};

export const deleteActualStock = async (id: number) => {
	const response = await api.delete(`estoque?id=${id}`);
	return response.data;
};

export const deleteActualStockByFilters = async (filters: any) => {
	const response = await api.post('estoque/deletarPorFiltros', filters);
	return response.data;
};
